import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { View3dGlobal } from '../../../view3d/webcad';
import { AddCeilingItemLoader } from '../../../view3d/webcad/loader/AddCeilingItemLoader';
import { AddWallItemLoader } from '../../../view3d/webcad/loader/AddWallitemLoader';
import { AddFloorItemLoader } from '../../../view3d/webcad/loader/AddFloorItemLoader';

import * as roomMaterial from '../../../view3d/webcad/material'
import { AddPin } from '../../../view3d/webcad/loader/AddPin';
import { AddSiteItemLoader } from '../../../view3d/webcad/loader/AddSiteItemLoader';
import { ObjectType } from '../../../view3d/webcad/ObjectType'

declare global {
  let floorItem: JSON;
  let wallItem: JSON;
  let ceilingItem: JSON;
  let exteriorItem: JSON;
}

/**
 * 3Dーテクスチャ変更
 * 対象：壁、床、天井
 */
export default class TextureAndItemDialog extends Dialog {
  public target: any = undefined;

  public $tree: any = null;

  static tabId = 'tab_2';

  static treeState = {};

  public itemListHtmlStr = ''; // 画像読み込み高速化のために外に置く

  public openCallback: Function = undefined;
  public closeCallback: Function = undefined;

  /**
   * コンストラクタ
   */
  // eslint-disable-next-line no-useless-constructor
  constructor(draggable: boolean) {
    super(draggable);
  }

  private innerWall(obj: THREE.Object3D) {
    return ObjectType.isInnerWall(obj);
  }

  private ceiling(obj: THREE.Object3D) {
    return ObjectType.isCeiling_(obj);
  }

  private floor(obj: THREE.Object3D) {
    return ObjectType.isFloor_(obj)
  }

  private outerWall(obj: THREE.Object3D) {
    return ObjectType.isOuterWall(obj);
  }

  //外構判定
  private site(obj: THREE.Object3D) {
    return ObjectType.isSite(obj);
  }

  buildContent() {
    // ダイアログのコンテンツ生成
    const id = 'dialogTextureAndItem';

    let title = '';
    let contents = '<div class="tabWrap">';
    if (this.outerWall(this.target)) {
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'jp': title = '外壁変更'; break;
        default: title = 'Change Material'; break;
      }
      contents += '<div class="textureChangeList"></div>';
    } else if (this.site(this.target)) {
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'jp': title = 'アイテム追加'; break;
        default: title = 'Add Item'; break;
      }
      contents += '<div class="addItemCategorySelect"></div>';
      contents += '<div class="addItemList"><ul><ul></div>';
    } else {
      contents += '<input id="tab_1" type="radio" name="tabs" class="tabSwitch">';
      let tab1Name = '';
      if (this.innerWall(this.target)) {
        tab1Name = '<span class="jp">壁紙変更</span><span class="en">Texture</span>';
      } else if (this.ceiling(this.target) || ObjectType.isGirder(this.target)) {
        tab1Name = '<span class="jp">天井材変更</span><span class="en">Texture</span>';
      } else if (this.floor(this.target)) {
        tab1Name = '<span class="jp">床材変更</span><span class="en">Texture</span>';
      } else if (this.outerWall(this.target)) {
        tab1Name = '<span class="jp">天井材変更</span><span class="en">Texture</span>';
      }
      contents += `<label class="tabLabel" for="tab_1" data-tabType="texture" data-tabIndex="1">${tab1Name}</label>`;
      contents += '<div class="tabContent tabContent1">';
      contents += '<div class="textureChangeList"></div>';
      contents += '</div>';
      contents += '<input id="tab_2" type="radio" name="tabs" class="tabSwitch">';
      contents += '<label class="tabLabel" for="tab_2" data-tabType="item" data-tabIndex="2"><span class="jp">アイテム追加</span><span class="en">Add Item</span></label>';
      contents += '<div class="tabContent tabContent2">';
      contents += '<div class="addItemCategorySelect"></div>';
      contents += '<div class="addItemList"><ul><ul></div>';
      contents += '</div>';
    }
    contents += '</div>';

    const footer = '';

    this.createDialog(id, title, contents, footer);

    document.getElementById('dialogTextureAndItem').classList.add(`${this.site(this.target) ? 'siteMode' : 'notSiteMode'}`);
    document.getElementById('dialogTextureAndItem').classList.add(`${this.outerWall(this.target) ? 'outerWallMode' : 'notOuterWallMode'}`);
    this.createTextureList();
    this.createCategoryTree();
    this.setEvent();
    this.setInit();
    this.updateCurrent();

    if (this.openCallback != null) {
      this.openCallback();
    }
  }

  /*
  * 操作状態の復元
  */
  setInit() {
    if (!this.site(this.target) && !this.outerWall(this.target)) {
      (document.getElementById(`${TextureAndItemDialog.tabId}`) as HTMLInputElement).checked = true;
      const overFlow = TextureAndItemDialog.tabId === 'tab_1' ? 'auto' : 'hidden';
      (document.querySelector('#dialogTextureAndItem .dialogBody') as HTMLElement).style.overflowY = overFlow;
      (document.querySelector('#dialogTextureAndItem .dialogBody .tabWrap') as HTMLElement).style.overflowY = overFlow;
    } else {
      (document.querySelector('#dialogTextureAndItem .dialogBody') as HTMLElement).style.overflowY = 'hidden';
      (document.querySelector('#dialogTextureAndItem .dialogBody .tabWrap') as HTMLElement).style.overflowY = 'hidden';
    }
    if (!this.outerWall(this.target)) {
      (document.querySelector('#dialogTextureAndItem .addItemCategorySelect') as HTMLElement).style.width = `${String(this.$tree.width() + 10)}px`;
      const treeNodeOpen = (idList: string[] = null) => {
        // 全階層を閉じる
        this.$tree.tree('getState').open_nodes.forEach((id) => {
          const node = this.$tree.tree('getNodeById', id);
          this.$tree.tree('closeNode', node, false);
        });
        if (idList) {
          idList.forEach((id) => {
            const node = this.$tree.tree('getNodeById', id);
            this.$tree.tree('openNode', node, false);
          });
        } else {
          const node = this.$tree.tree('getNodeById', 'all');
          this.$tree.tree('openNode', node, false);
        }
      }
      if (TextureAndItemDialog.treeState[this.target.userData.sub_type]) {
        // 階層の展開状態を復元
        treeNodeOpen(TextureAndItemDialog.treeState[this.target.userData.sub_type].open_nodes);
        const id = TextureAndItemDialog.treeState[this.target.userData.sub_type].selected_node[0] || 'all';
        this.$tree.tree('getNodeById', id).element.querySelector('span').click();
      } else {
        // 全てのみ開く
        treeNodeOpen(null);
        this.$tree.tree('getNodeById', 'all').element.querySelector('span').click();
      }
    }
  }

  /**
   * テクスチャリストの生成
   */
  private createTextureList() {
    if (this.innerWall(this.target) || this.ceiling(this.target) || ObjectType.isGirder(this.target) || this.outerWall(this.target)) {
      const textureData = !this.outerWall(this.target) ? marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Cloth) : marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Wall, 1);
      let contents = '<ul>';
      for (let i = 0; i < textureData.length; i += 1) {
        contents += `<li data-name="${textureData[i].name}" class="btnTextureChange" data-textureIndex="${String(i)}">`;
        contents += `<button id="textureChange${String(i)}">`;
        contents += `<img src="${textureData[i].thumbnail}" width="76" height="76"/><div class="currentFrame"></div></button>`;
        let name = textureData[i].name.replace('（', '<span style="display: inline-block;">（');
        name = name.replace('）', '）</span>');
        contents += `<p>${name}</p>`;
        contents += '</li>';
      }
      contents += '</ul>';
      document.querySelector('#dialogTextureAndItem .textureChangeList').innerHTML = contents;
    } else if (this.floor(this.target)) {
      const textureData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Floor);
      const groupByCategory = textureData.reduce((group, floor) => {
        const { category } = floor;
        group[category] = group[category] ?? [];
        group[category].push(floor);
        return group;
      }, {});
      const categorys = {
        white: {
          title: 'ホワイト系',
          title_en: 'White',
        },
        light: {
          title: 'ライト系',
          title_en: 'Light',
        },
        medium: {
          title: 'ミディアム系',
          title_en: 'Medium',
        },
        dark: {
          title: 'ダーク系',
          title_en: 'Dark',
        },
      };
      const groupData = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const category in categorys) {
        if (groupByCategory[category]) {
          groupData[category] = groupByCategory[category];
        }
      }
      let contents = '<ul class="floorMode">';
      for (const category in groupData) {
        if (groupData.hasOwnProperty(category)) {
          contents += `<span class="floorTextureCategoryTitle"><span class="jp">${categorys[category].title}</span><span class="en">${categorys[category].title_en}</span></span>`;
          contents += '<ul>';
          if (groupData[category] !== undefined) {
            for (let i = 0; i < groupData[category].length; i += 1) {
                const floorIndex = textureData.findIndex((floor) => floor.name === groupByCategory[category][i].name);
                contents += `<li data-name="${groupData[category][i].name}" class="btnTextureChange" data-textureIndex="${String(floorIndex)}">`;
                contents += `<button id="textureChange${String(i)}">`;
                contents += `<img src="${groupData[category][i].thumbnail}" width="56" height="56"/><div class="currentFrame"></div></button>`;
                contents += `<p>${groupData[category][i].name}</p>`;
                contents += '</li>';
            }
          }
          contents += '</ul>';
        }
      }
      contents += '</ul>';
      document.querySelector('#dialogTextureAndItem .tabContent1 .textureChangeList').innerHTML = contents;
      (document.querySelector('#dialogTextureAndItem .tabContent1') as HTMLElement).style.width = '250px';
    }
  }

  /*
  * 追加アイテムのカテゴリー切り換えボタン
  */
  private createCategoryTree = () => {
    if (this.outerWall(this.target)) return;
    let contents = '<div id="categoryTree"></div>';
    let Json: JSON = null;
    switch (true) {
      case this.floor(this.target): Json = floorItem; break;
      case this.innerWall(this.target): Json = wallItem; break;
      case this.ceiling(this.target): Json = ceilingItem; break;
      case ObjectType.isGirder(this.target): Json = ceilingItem; break;
      case this.site(this.target): Json = exteriorItem; break;
      default: Json = null; break;
    }
    document.querySelector('#dialogTextureAndItem .addItemCategorySelect').innerHTML = contents;
    this.$tree = ($('#categoryTree') as any);
    this.$tree.tree({ // JSONデータのセット
      data: Json,
      autoOpen: true,
    });
  }

  /**
   * アイテムリストの生成
   */
  private createItemList(itemId: string[]) {
    /* if (this.category[category] === 'Pin') {
      new AddPin(this.target);
      this.close();
      return;
    } */
    const dir = View3dGlobal.shared.itemDir;
    // アイテムリストの生成
    itemId.forEach((id) => {
      const data = View3dGlobal.threeView.planmgr.autoData.alternativeId(id);
      if (data) {
        const imgPath = dir + data.item.thumbnail;
        this.itemListHtmlStr += `<li class="btnAddItem" data-itemid=${data.itemId} data-index=${data.index + 1}>`;
        this.itemListHtmlStr += `<button id="addItem${data.index + 1}">`;
        this.itemListHtmlStr += '<div class="imbBox">';
        this.itemListHtmlStr += `<img src="${imgPath}" width="76" height="76" loading="lazy"/>`;
        this.itemListHtmlStr += '</div>';
        this.itemListHtmlStr += '</li>';
      }
    });
  }

  /**
   * イベントの生成
   */
  setEvent() {
    document.querySelectorAll('#dialogTextureAndItem .tabWrap .tabLabel').forEach((elem) => {
      elem.addEventListener('click', (e) => {
        let overFlow = '';
        overFlow = (e.currentTarget as HTMLElement).getAttribute('data-tabType') === 'texture' ? 'auto' : 'hidden';
        (document.querySelector('#dialogTextureAndItem .dialogBody') as HTMLElement).style.overflowY = overFlow;
        (document.querySelector('#dialogTextureAndItem .dialogBody .tabWrap') as HTMLElement).style.overflowY = overFlow;
        (document.querySelector(`#dialogTextureAndItem #tab_${(e.currentTarget as HTMLElement).getAttribute('data-tabIndex')}`) as HTMLInputElement).checked = true;
        (document.querySelector('#dialogTextureAndItem .addItemCategorySelect') as HTMLElement).style.width = `${String(this.$tree.width() + 10)}px`;
      });
    });
    document.querySelectorAll('#dialogTextureAndItem .textureChangeList li').forEach((elem) => {
      elem.addEventListener('click', (e) => {
        const textureIndex = Number(((e.currentTarget) as HTMLElement).getAttribute('data-textureIndex'));
        let changePoint: roomMaterial.ChangePointWall | roomMaterial.ChangePointCeiling | roomMaterial.ChangePointFloor | roomMaterial.ChangePointOutWall = undefined;
        if (this.innerWall(this.target)) {
          // 壁のテクスチャ変更
          changePoint = new roomMaterial.ChangePointWall(this.target);
        } else if (this.ceiling(this.target) || ObjectType.isGirder(this.target)) {
          // 天井のテクスチャ変更
          // 梁のテクスチャ変更
          changePoint = new roomMaterial.ChangePointCeiling(this.target);
        } else if (this.floor(this.target)) {
          // 床のテクスチャ変更
          changePoint = new roomMaterial.ChangePointFloor(this.target);
        } else if (this.outerWall(this.target)) {
          // 外壁のテクスチャ変更
          changePoint = new roomMaterial.ChangePointOutWall(this.target);
        }
        changePoint.setMaterial(textureIndex);
        this.close();
      });
    });
    this.$tree?.on(
      'tree.click',
      (e) => {
        const { node } = e;
        if (node.id === 'pin') {
          const pin = new AddPin();
          pin.click(this.target);
          this.close();
          return;
        }
        // 既に選択状態ならスキップ
        if (this.$tree.tree('getNodeById', node.id)?.element.querySelector('span').classList.contains('listActive')) return;
        // リストを初期化
        document.querySelector('#dialogTextureAndItem .addItemList ul').innerHTML = '';
        this.itemListHtmlStr = '';
        // current表示の更新
        document.getElementById('categoryTree').querySelector('.listActive')?.classList.remove('listActive');
        this.$tree.tree('getNodeById', node.id).element.querySelector('span').classList.add('listActive');
        if (node) {
          const searchItemId = (itemObjArr) => {
            if (itemObjArr.itemId && itemObjArr.itemId.length) { // アイテムIDを持っている場合
              this.createItemList(itemObjArr.itemId); // アイテムリストの生成
            }
            if (itemObjArr.children && itemObjArr.children.length) { // 子カテゴリ内の検索
              itemObjArr.children.some((obj) => searchItemId(obj));
            }
          };
          searchItemId(node);
        }
        // リスト生成
        document.querySelector('#dialogTextureAndItem .addItemList ul').innerHTML += this.itemListHtmlStr;
        // イベント生成
        document.querySelectorAll('#dialogTextureAndItem .addItemList .btnAddItem').forEach((elem) => {
          elem.addEventListener('click', (e) => {
            const itemId = (e.currentTarget as HTMLElement).getAttribute('data-itemid');
            const index = (e.currentTarget as HTMLElement).getAttribute('data-index');
            this.close();
            if (this.innerWall(this.target)) {
              // 壁にアイテムを追加
              // eslint-disable-next-line no-new
              new AddWallItemLoader(itemId, index);
            } else if (this.ceiling(this.target) || ObjectType.isGirder(this.target)) {
              // 天井アイテムの追加
              // eslint-disable-next-line no-new
              new AddCeilingItemLoader(itemId, index);
            } else if (this.floor(this.target)) {
              // 床アイテムの追加
              // eslint-disable-next-line no-new
              new AddFloorItemLoader(itemId, index);
            } else if (this.site(this.target)) {
              // 外構アイテムの追加
              // eslint-disable-next-line no-new
              new AddSiteItemLoader(itemId, index);
            } else if (this.outerWall(this.target)) {
            // 外構アイテムの追加
            // eslint-disable-next-line no-new
            new AddSiteItemLoader(itemId, index);
          }
          });
        });
      },
    );
  }

  /*
  * カレント表示の追加
  */
  updateCurrent() {
    const element = document.querySelector(`#dialogTextureAndItem .textureChangeList [data-name='${this.target.material.map.userData.title}']`);
    if (element) element.closest('li').classList.add('is-active');
  }

  /**
  * ダイアログを閉じる
  */
  closeEvent() {
    // 操作状態の保存
    const tabId = (!this.site(this.target) && !this.outerWall(this.target)) ? document.querySelector('#dialogTextureAndItem .tabSwitch:checked').id : TextureAndItemDialog.tabId;
    TextureAndItemDialog.tabId = tabId;
    if (this.$tree) TextureAndItemDialog.treeState[this.target.userData.sub_type] = this.$tree.tree('getState');

    this.viewObj.remove();
    if (this.showHeaderCloseButton) {
      this.viewObj.querySelector('.dialogCloseBtn').removeEventListener('click', this.close);
    }

    // コールバックのお掃除関数
    if (this.globalCleanUpFunc) this.globalCleanUpFunc();

    if (this.prevDialog) {
      marietta.webcad.WebCADGlobal.currentDialog = this.prevDialog;
      if (marietta.webcad.WebCADGlobal.currentDialog.hasModal)marietta.webcad.WebCADGlobal.currentDialog.handleModal();
    }

    // 3Dの場合
    if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '3D') {
      marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
    }

    // // モーダルのデザインを元に戻す
    // document.getElementById('modalBg').style.backgroundColor = '#000';
    // document.getElementById('modalBg').style.opacity = '.6';
    // document.getElementById('modalBg').style.pointerEvents = 'auto';

    if (this.closeCallback != null) {
      this.closeCallback();
    }
  }
}
